const getSeasons = () => {
  return JSON.parse(localStorage.getItem('selectedCropSeasons'));
};

export default getSeasons;
